import { useEffect, useState } from "react";

export function useInterval(isOn: boolean, intervalMs: number, onInterval: () => void) {
  const [s, setS] = useState(0);

  function onTick() {
    onInterval();

    setS(s => s + 1);
  }

  useEffect(() => {
    setS(0);

    const id = window.setInterval(onTick, intervalMs);

    return () => {
      window.clearInterval(id);
    };
  }, [isOn]);

  return s;
}
